import { useQuery } from '@pinia/colada';
import { computed, MaybeRefOrGetter, toValue } from 'vue';

import conversationService from '../services/conversation.service';

export const renterChatTranscriptQueryKey = 'renter-chat-transcript';

export function getRenterChatTranscriptQueryKey(propertyId: string, userId: string) {
  return ['conversation', renterChatTranscriptQueryKey, propertyId, userId];
}

/**
 * Loads a renter's chat transcript(s) for a property (`GET /conversation/renter-chat-transcript/...`).
 * `enabled`-gated so the conversation sidebar only fetches when it is actually open, rather than once
 * per summary card rendered on the dashboard.
 */
export function useRenterChatTranscriptQuery(
  propertyId: MaybeRefOrGetter<string | null | undefined>,
  userId: MaybeRefOrGetter<string | null | undefined>,
  enabled: MaybeRefOrGetter<boolean>,
) {
  const propertyIdValue = computed(() => toValue(propertyId));
  const userIdValue = computed(() => toValue(userId));

  return useQuery({
    key: () => getRenterChatTranscriptQueryKey(propertyIdValue.value!, userIdValue.value!),
    enabled: () => toValue(enabled) && Boolean(propertyIdValue.value) && Boolean(userIdValue.value),
    query: () => conversationService.getByPropertyAndUser(propertyIdValue.value!, userIdValue.value!),
  });
}
